// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","homeI":"Home_homeI__5Mm7z","image":"Home_image__T5Jrw"};